import { createFileRoute } from "@tanstack/react-router";
import type { ReminderTypeCode, RemindersSort } from "@shared/reminders-data";
import { REMINDER_TYPE_CODES } from "@shared/reminders-data";
import RemindersPrintPage from "@/site/pages/reminders-print";

// Chrome-free print page opened in a new tab by the reminders toolbar (old
// /reminders-print-view). Renders outside SiteLayout — see __root.tsx.
interface PrintSearch {
  sort?: RemindersSort;
  type?: ReminderTypeCode;
}

function isReminderType(value: unknown): value is ReminderTypeCode {
  return typeof value === "string" && (REMINDER_TYPE_CODES as readonly string[]).includes(value);
}

export const Route = createFileRoute("/reminders-print-view")({
  validateSearch: (search: Record<string, unknown>): PrintSearch => {
    const out: PrintSearch = {};
    if (search.sort === "first" || search.sort === "last") out.sort = search.sort;
    if (isReminderType(search.type)) out.type = search.type;
    return out;
  },
  component: RemindersPrintPage,
});
